var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuayThai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 255 255",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-1);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #ff5134;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fc0231;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #1c8cea;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-1",
    gradientUnits: "userSpaceOnUse",
    x1: 101.109,
    y1: 136.594,
    x2: 101.109,
    y2: -0.312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd7507"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boxing_glove"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.871,8.803 C133.871,8.803 156.544,29.945 156.544,29.945 C156.544,29.945 54.926,136.917 54.926,136.917 C54.926,136.917 50.538,132.825 50.538,132.825 C47.306,129.812 46.770,126.235 46.585,120.935 C46.435,116.636 41.734,65.086 84.700,19.011 C109.342,-7.414 122.562,-1.743 133.871,8.803 Z",
    id: "path-1",
    className: "cls-3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.293,9.270 C181.293,9.270 243.458,67.240 243.458,67.240 C256.383,79.293 258.549,100.910 250.157,117.241 C219.101,177.676 135.711,203.312 135.711,203.312 C130.991,204.952 127.148,206.265 122.210,201.661 C122.210,201.661 50.538,134.825 50.538,134.825 C47.306,131.811 47.130,126.749 50.143,123.518 C50.143,123.518 136.066,10.849 136.066,10.849 C148.119,-2.076 168.368,-2.783 181.293,9.270 Z",
    id: "path-2",
    className: "cls-4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.463,137.553 C55.463,137.553 122.748,200.297 122.748,200.297 C125.979,203.310 126.156,208.372 123.142,211.603 C123.142,211.603 84.951,252.559 84.951,252.559 C81.937,255.791 76.875,255.967 73.644,252.954 C73.644,252.954 6.359,190.210 6.359,190.210 C3.128,187.197 2.951,182.135 5.964,178.903 C5.964,178.903 44.156,137.948 44.156,137.948 C47.169,134.716 52.232,134.539 55.463,137.553 Z",
    id: "path-3",
    className: "cls-5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.479,133.590 C35.479,133.590 108.614,201.790 108.614,201.790 C111.845,204.803 112.022,209.866 109.009,213.097 C109.009,213.097 84.457,239.426 84.457,239.426 C81.444,242.657 76.382,242.834 73.150,239.820 C73.150,239.820 0.015,171.621 0.015,171.621 C0.015,171.621 35.479,133.590 35.479,133.590 Z",
    id: "path-4",
    className: "cls-4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.023,139.441 C30.023,139.441 99.501,204.231 99.501,204.231 C101.521,206.114 101.631,209.278 99.748,211.298 C99.748,211.298 82.016,230.313 82.016,230.313 C80.133,232.333 76.969,232.443 74.949,230.560 C74.949,230.560 5.471,165.770 5.471,165.770 C5.471,165.770 30.023,139.441 30.023,139.441 Z",
    id: "path-5",
    className: "cls-7",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuayThai);
export default __webpack_public_path__ + "static/media/muay-thai.37819fcaeb627c6bffdb68308bab7d19.svg";
export { ForwardRef as ReactComponent };